module.exports = __webpack_public_path__ + "static/media/template-icon-green.43a598f1.svg";